import React, { useEffect, useState } from "react";
import "./CustomDatePicker.css"

const CustomDatePicker = ({ question, label, updateResponse, customerResponse }) => {

  const userDob = question.userType === "Proposer" ? localStorage.getItem('proposerDob') : localStorage.getItem('insurerDob')
  const fiveYearLogicQuestIds = sessionStorage.getItem('fiveYearLogicQuestIds')
  const fiveYrIdsArr = fiveYearLogicQuestIds ? fiveYearLogicQuestIds.split(',') : []
  const isFiveYrLogicApplicable = fiveYrIdsArr.includes(question.qstId)
  const dob = userDob.split("-");
  const currentYear = new Date().getFullYear();
  const dobYear = isFiveYrLogicApplicable ? currentYear - 5 : parseInt(dob[2]);
  const dobMonth = parseInt(dob[1])
  const yearDropdownArr = Array.from(
    { length: currentYear - dobYear + 1 },
    (_, i) => i + dobYear
  );

  const [showCalender, setShowCalender] = useState(false)
  const [months, setMonths] = useState([])
  const [selectedMonth, setSelectedMonth] = useState(dobMonth)
  const [selectedYear, setSelectedYear] = useState(dobYear)

  useEffect(() => {
    handleValidMonths()
  }, [selectedYear])

  const handleValidMonths = () => {
    const monthsArr = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    if (parseInt(selectedYear) === dobYear) {
      const validMonths = monthsArr.filter((m) => parseInt(m) >= parseInt(dobMonth))
      setMonths(validMonths)
      if (selectedMonth < dobMonth) {
        setSelectedMonth(dobMonth)
      }
    } else if(parseInt(selectedYear) === currentYear) {
      const currentMonth = new Date().getMonth() + 1
      const validMonths = monthsArr.filter((m) => parseInt(m) <= parseInt(currentMonth))
      setMonths(validMonths)
      if(selectedMonth > currentMonth) {
        setSelectedMonth(currentMonth)
      }
    } else {
      setMonths(monthsArr)
    }
  }

  const handleCalenderChange = () => {
    const value = `${selectedMonth < 10 ? `0${parseInt(selectedMonth)}` : selectedMonth}/${selectedYear}`
    if(!selectedMonth || !selectedYear) {
      updateResponse(null, question, "calender2")
    } else {
      updateResponse(value, question, "calender2")
    }
    setShowCalender(false)
  }

  return (
    <>
      <div className="calender-cust-rspns" onClick={() => setShowCalender(true)}>
        <p>{label}</p>
        <p className="rspns">{customerResponse ?? "MM/YYYY"}</p>
      </div>
      {showCalender && <div className="calender-mnth-yr-inp">
        <div className="calender-grp">
          <div className="month-drpdwn">
            <select value={selectedMonth < 10 ? `0${parseInt(selectedMonth)}` : selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} >
              <option value={""}>MM</option>
              {
                months.length > 0 && months.map((month) => (
                  <option key={month} value={month}>{month}</option>
                ))
              }
            </select>
          </div>
          <div className="year-drpdwn">
            <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
            <option value={""}>YYYY</option>
              {
                yearDropdownArr.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))
              }
            </select>
          </div>
          <div className="clnr-btn" onClick={handleCalenderChange}>
            Ok
          </div>
        </div>
      </div>}
    </>
  );
};

export default CustomDatePicker;
